
import React from 'react';
import { StorageService } from '../services/db';

export const Gallery: React.FC = () => {
  const images = StorageService.getGallery();

  return (
    <div className="pt-24 pb-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto py-24 space-y-32">
        {/* Header Section */}
        <div className="text-center space-y-6 max-w-2xl mx-auto">
          <p className="text-[10px] font-bold uppercase tracking-[0.5em] text-stone-400">Visual Experience</p>
          <h1 className="text-5xl lg:text-7xl font-light uppercase tracking-tight">Gallery</h1>
          <p className="text-stone-500 text-lg">Every detail of the Stealth modular system is meticulously crafted for both aesthetic perfection and functional longevity.</p>
        </div>

        {/* Video Section - Dedicated as requested */}
        <section className="space-y-12">
          <div className="flex items-center space-x-6">
            <h2 className="text-2xl font-light uppercase tracking-widest shrink-0">Video Overview</h2>
            <div className="h-[1px] bg-stone-100 w-full" />
          </div>
          <div className="grid lg:grid-cols-2 gap-8">
            <div className="bg-stone-900 rounded-[3rem] p-6 text-white shadow-2xl">
              <div className="aspect-video w-full bg-stone-800 rounded-3xl overflow-hidden">
                 <iframe 
                   className="w-full h-full" 
                   src="https://www.youtube.com/embed/dQw4w9WgXcQ" 
                   title="Stealth Interior Tour"
                   frameBorder="0" 
                   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                   allowFullScreen
                 ></iframe>
              </div>
              <div className="p-8 space-y-2">
                <h4 className="text-xl font-light uppercase tracking-tight">Interior Walkthrough</h4>
                <p className="text-stone-500 text-xs uppercase font-bold tracking-widest">A deep dive into the 2025 Stealth Edition</p>
              </div>
            </div>
            
            <div className="bg-stone-50 rounded-[3rem] p-6 text-stone-900 border border-stone-100">
              <div className="aspect-video w-full bg-stone-200 rounded-3xl overflow-hidden relative group cursor-pointer">
                 <div className="absolute inset-0 bg-stone-900/40 group-hover:bg-stone-900/20 transition-all flex items-center justify-center">
                    <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-xl">
                       <svg className="w-6 h-6 ml-1" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                    </div>
                 </div>
                 <img src="https://lh3.googleusercontent.com/d/1OOUOfMirVTk4bv7CE4LtN90ELFVx6O3W" className="w-full h-full object-cover" alt="Construction Video" />
              </div>
              <div className="p-8 space-y-2">
                <h4 className="text-xl font-light uppercase tracking-tight">Construction Speed</h4>
                <p className="text-stone-500 text-xs uppercase font-bold tracking-widest">3 days. 1 module. Ready to live.</p>
              </div>
            </div>
          </div>
        </section>
        
        {/* Photo Grid Section */}
        <section className="space-y-12">
          <div className="flex items-center space-x-6">
            <h2 className="text-2xl font-light uppercase tracking-widest shrink-0">Photo Collection</h2>
            <div className="h-[1px] bg-stone-100 w-full" />
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {images.map((img) => (
              <div key={img.id} className="overflow-hidden rounded-2xl group cursor-zoom-in shadow-sm hover:shadow-xl transition-all border border-stone-100">
                <img 
                  src={img.url} 
                  className="w-full aspect-square object-cover transition-transform duration-700 group-hover:scale-110" 
                  alt={img.title || 'Stealth View'} 
                />
              </div>
            ))}
            {images.length === 0 && (
              <div className="col-span-full py-20 text-center text-stone-400 uppercase tracking-widest font-bold">
                Gallery is currently empty.
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};
